<template>
  <div class="dash-section">
    <div class="dash-sub-section">
      <div class="header">
        <h3>Usage Over Time</h3>

        <label class="chart-control">
          <span class="sr-only">By</span>
          <select :value="credits.usage.parameters.binBy" @input="setBinBy">
            <option value="year">Yearly</option>
            <option value="quarter">Quarterly</option>
            <option value="month">Monthly</option>
            <option value="week">Weekly</option>
            <option value="day">Daily</option>
          </select>
        </label>
      </div>
      <usage-over-time-chart
        :loading="credits.usage.loading"
        :binned-from-date="credits.usage.from"
        :through-date="credits.usage.through"
        :bin-by="credits.usage.parameters.binBy"
        :binned-credits-used="usage.creditsUsed"
        :binned-students-that-used-credits="
          usage.studentsThatUsedCredits
        "
      />
    </div>
    <div class="dash-sub-section">
      <div class="header">
        <h3>Credit Use Distribution</h3>
      </div>
      <distribution-chart
        :loading="credits.counts.loading"
        :average-per-student="counts.averagePerStudent"
        :histogram="counts.creditUseHistogram"
      />
    </div>
  </div>
</template>

<script>
import AdminClient from '@/api/AdminClient';
import moment from 'moment';
import DistributionChart from './DistributionChart.vue';
import UsageOverTimeChart from './UsageOverTimeChart.vue';
import Skeleton from '../../../Skeleton.vue';

export default {
  name: 'CreditUsage',

  components: {
    DistributionChart,
    UsageOverTimeChart,
    Skeleton
  },

  inject: ['credits'],

  props: {
    creditType: {
      type: String,
      required: true,
      default: 'individual'
    }
  },

  data() {
    return {
      adminClient: new AdminClient(this.$http),
      exporting: false
    };
  },

  computed: {

    counts() {
      if(this.creditType === 'individual')
        return this.credits.counts.individual;
      return this.credits.counts.workshop;
    },

    usage() {
      if(this.creditType === 'individual')
        return this.credits.usage.individual;
      return this.credits.usage.workshop;
    },
  },

  methods: {
    setBinBy(e) {
      this.credits
        .byBin(e.target.value)
        .fetchBin();
    },
    async exportUsage() {
      this.exporting = true;

      const csv = await this.adminClient.getStudentCreditUsageCSV(
        this.credits.schoolId,
        this.credits.from,
        this.credits.through
      );
      const blob = new Blob([csv]);

      const downloadLink = document.createElement('a');
      downloadLink.href = URL.createObjectURL(blob);
      downloadLink.download = `bettermynd-student-credit-usage-${moment().format(
        'yyyyMMddHHmmss'
      )}.csv`;

      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);

      this.exporting = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.dash-sub-section {
  margin-top: 0px;
}
.wasted{
  font-style: italic;
  padding: 1rem 0 0 2.25rem;
}

.actions {
  display: flex;
  align-items: center;
}

.export-toggle {
  background: #fff;
  height: 46px;
  border-radius: 8px;
  width: 46px;
  margin-left: 8px;
  border: 1px solid #d1d1d1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #1d1c1c;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  text-align: center;

  &:hover {
    box-shadow: 0 2px 4px rgb(0 0 0 / 18%);
    border-color: #bababa;
  }
}

.dates {
  color-scheme: light;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #d1d1d1;
  padding: 0;
  margin: 0;
  height: 46px;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  text-align: center;

  @media screen and (min-width: $md-min) {
    height: 46px;
    flex-wrap: nowrap;
  }

  label {
    margin: 0;
  }

  input {
    border: 0;
    background: transparent;
    line-height: 1;
    font-size: 14px;
    font-weight: 500;
    text-transform: uppercase;
    max-width: 143px;
    height: 46px;
    padding: 0 16px;
  }

  svg {
    opacity: 0.8;
  }

  &:hover {
    box-shadow: 0 2px 4px rgb(0 0 0 / 18%);
    border-color: #bababa;
  }
}
.chart-control select {
  color: #6b6e88;
  border: none;
  font-weight: 500;
  font-size: 16px;
  border-radius: $border-radius;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  padding: 2px 0;

  &:hover {
    background: #e4e4e4;
    color: inherit;
  }
}
</style>
